import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import type { JadwalBlokir } from '@/types'

export function useJadwalBlokir() {
  const [jadwal, setJadwal] = useState<JadwalBlokir[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase
      .from('jadwal_blokir')
      .select('*')
      .eq('aktif', true)
      .then(({ data }) => {
        setJadwal(data ?? [])
        setLoading(false)
      })
  }, [])

  return { jadwal, loading }
}

// Generate hourly slots from startHour to endHour (exclusive)
export function generateSlots(start = 6, end = 22): number[] {
  return Array.from({ length: end - start }, (_, i) => start + i)
}

// Check if a slot hour is blocked for a given day
export function isBlocked(slotHour: number, dayOfWeek: number, jadwal: JadwalBlokir[]): boolean {
  return jadwal
    .filter(j => j.aktif && j.hari === dayOfWeek)
    .some(j => {
      const mulai = parseInt(j.jam_mulai.split(':')[0])
      const selesai = parseInt(j.jam_selesai.split(':')[0])
      return slotHour >= mulai && slotHour < selesai
    })
}

// Check if a slot is in the past (only relevant when date = today)
export function isPast(slotHour: number, tanggal: string): boolean {
  const today = new Date().toISOString().split('T')[0]
  if (tanggal !== today) return false
  return slotHour <= new Date().getHours()
}
